export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.024 9.25a.75.75 0 01.647.415l5 10A.75.75 0 0120 20.75H4a.75.75 0 01-.61-1.186l5-7a.75.75 0 011.186-.044l1.815 2.178 2.961-5.076a.75.75 0 01.672-.372zm-.075 2.325l-2.801 4.803a.75.75 0 01-1.224.102l-1.878-2.254-3.589 5.024h13.33l-3.838-7.675z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.25 4a.75.75 0 01.75-.75h4a.75.75 0 01.75.75v6h-1.5V7.75H11a.75.75 0 01-.75-.75V4zm4 2.25v-1.5h-2.5v1.5h2.5z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};